module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px 0 20px 30px",
      "border": "0px solid red"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "margin-right": "0px"
    },
    attrs: {
      "size": "mini"
    },
    on: {
      "change": _vm.clickEvent
    },
    model: {
      value: (_vm.clickMenubarName),
      callback: function($$v) {
        _vm.clickMenubarName = $$v
      },
      expression: "clickMenubarName"
    }
  }, _vm._l((_vm.menubarFun), function(item) {
    return _c('el-radio', {
      key: item.id,
      staticStyle: {
        "margin-right": "4px"
      },
      attrs: {
        "border": "",
        "title": item.name,
        "label": item.name
      }
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n      ")])
  }), 1), _vm._v("\n    边框颜色：\n    "), _c('el-color-picker', {
    staticClass: "select-color",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.borderColorChange
    },
    model: {
      value: (_vm.borderColor),
      callback: function($$v) {
        _vm.borderColor = $$v
      },
      expression: "borderColor"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("\n      线条宽度：\n      "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 1,
      "max": 5,
      "size": "mini"
    },
    on: {
      "change": _vm.borderWidthChange
    },
    model: {
      value: (_vm.borderWidth),
      callback: function($$v) {
        _vm.borderWidth = $$v
      },
      expression: "borderWidth"
    }
  })], 1), _vm._v(" "), _c('span', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "width": "80px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.resetCanvas
    }
  }, [_vm._v("重置画布")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "width": "80px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.undo
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.saveFile
    }
  }, [_vm._v("保存上传")])], 1)], 1), _vm._v(" "), _c('canvas', {
    attrs: {
      "width": "600",
      "height": "650",
      "id": "canvas-box"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tip"
  }, [_vm._v("tip：定义画布内容后，请点击右上角保存上传")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ead9c010","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/activeModification/canvasBracket.vue
// module id = 681
// module chunks = 0